var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var ActionsContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n\n  > button {\n    font-size: 1.2rem;\n    padding: 6px 6px;\n    color: ", ";\n    border-color: ", ";\n    border-radius: ", ";\n    margin-right: 6px;\n    transition: color ", " ease,\n      background-color ", " ease,\n      border-color ", " ease;\n\n    svg {\n      fill: ", ";\n    }\n\n    &:last-child {\n      margin: 0;\n    }\n\n    &:hover {\n      color: ", ";\n      border-color: ", ";\n      background-color: ", ";\n      svg {\n        fill: ", ";\n      }\n    }\n    &:disabled {\n      color: ", " !important;\n      border-color: ", " !important;\n      svg {\n        fill: ", " !important;\n      }\n      cursor: not-allowed;\n      &:hover {\n        color: ", " !important;\n        border-color: ", " !important;\n        background-color: ", " !important;\n        svg {\n          fill: ", " !important;\n        }\n      }\n    }\n  }\n\n  > button.alt {\n    padding: 6px 8px;\n    color: ", ";\n    border-color: ", ";\n    svg {\n      fill: ", ";\n      margin-right: 4px;\n    }\n    &:hover {\n      color: ", ";\n      border-color: ", ";\n      background-color: ", ";\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n\n  > button.delete {\n    margin-left: 10px;\n  }\n"], ["\n  display: flex;\n\n  > button {\n    font-size: 1.2rem;\n    padding: 6px 6px;\n    color: ", ";\n    border-color: ", ";\n    border-radius: ", ";\n    margin-right: 6px;\n    transition: color ", " ease,\n      background-color ", " ease,\n      border-color ", " ease;\n\n    svg {\n      fill: ", ";\n    }\n\n    &:last-child {\n      margin: 0;\n    }\n\n    &:hover {\n      color: ", ";\n      border-color: ", ";\n      background-color: ", ";\n      svg {\n        fill: ", ";\n      }\n    }\n    &:disabled {\n      color: ", " !important;\n      border-color: ", " !important;\n      svg {\n        fill: ",
    " !important;\n      }\n      cursor: not-allowed;\n      &:hover {\n        color: ", " !important;\n        border-color: ", " !important;\n        background-color: ",
    " !important;\n        svg {\n          fill: ", " !important;\n        }\n      }\n    }\n  }\n\n  > button.alt {\n    padding: 6px 8px;\n    color: ", ";\n    border-color: ", ";\n    svg {\n      fill: ", ";\n      margin-right: 4px;\n    }\n    &:hover {\n      color: ", ";\n      border-color: ", ";\n      background-color: ", ";\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n\n  > button.delete {\n    margin-left: 10px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.error;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.error;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius;
}, function (_a) {
    var theme = _a.theme;
    return theme.transitions.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.transitions.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.transitions.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.error;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.error;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.error;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.lightText;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.lightText;
}, function (_a) {
    var theme = _a.theme;
    return theme.name === "default"
        ? theme.colors.lightText
        : theme.colors.ziggurat;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.lightText;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.lightText;
}, function (_a) {
    var theme = _a.theme;
    return theme.name === "default"
        ? theme.colors.lightText
        : theme.colors.ziggurat;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.accent1;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.accent1;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.accent1;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.accent1;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.accent1;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
});
var templateObject_1;
//# sourceMappingURL=ActionsContainer.js.map